import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';

export const GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS =
  'GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS';
export const GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS_SUCCESS =
  'GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS_SUCCESS';
export const GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS_FAILED =
  'GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS_FAILED';

export const GET_PUBLIC_WIFI_PXSPLUS_ACCOUNTS =
  'GET_PUBLIC_WIFI_PXSPLUS_ACCOUNTS';
export const GET_PUBLIC_WIFI_PXSPLUS_ACCOUNTS_SUCCESS =
  'GET_PUBLIC_WIFI_PXSPLUS_ACCOUNTS_SUCCESS';
export const GET_PUBLIC_WIFI_PXSPLUS_ACCOUNTS_FAILED =
  'GET_PUBLIC_WIFI_PXSPLUS_ACCOUNTS_FAILED';

export const CREATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS =
  'CREATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS';
export const CREATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_SUCCESS =
  'CREATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_SUCCESS';
export const CREATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_FAILED =
  'CREATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_FAILED';

export const UPDATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS =
  'UPDATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS';
export const UPDATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_SUCCESS =
  'UPDATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_SUCCESS';
export const UPDATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_FAILED =
  'UPDATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_FAILED';

export const UPDATE_PUBLIC_WIFI_PXSPLUS_PASSWORD =
  'UPDATE_PUBLIC_WIFI_PXSPLUS_PASSWORD';
export const UPDATE_PUBLIC_WIFI_PXSPLUS_PASSWORD_SUCCESS =
  'UPDATE_PUBLIC_WIFI_PXSPLUS_PASSWORD_SUCCESS';
export const UPDATE_PUBLIC_WIFI_PXSPLUS_PASSWORD_FAILED =
  'UPDATE_PUBLIC_WIFI_PXSPLUS_PASSWORD_FAILED';

export const RESET_PUBLIC_WIFI_PXSPLUS_MANAGE_VALUES =
  'RESET_PUBLIC_WIFI_PXSPLUS_MANAGE_VALUES';
export const RESET_PUBLIC_WIFI_PXSPLUS_CREATE_VALUES =
  'RESET_PUBLIC_WIFI_PXSPLUS_CREATE_VALUES';

export const GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL =
  'GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL';
export const GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL_SUCCESS =
  'GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL_SUCCESS';
export const GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL_FAILED =
  'GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL_FAILED';

export class GetPublicWifiPxsplusProducts implements Action {
  type = GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS;

  constructor(public payload?: any) {}
}

export class GetPublicWifiPxsplusProductsSuccess implements Action {
  type = GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetPublicWifiPxsplusProductsFailed implements Action {
  type = GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetPublicWifiPxsplusAccounts implements Action {
  type = GET_PUBLIC_WIFI_PXSPLUS_ACCOUNTS;

  constructor(public payload?: any) {}
}

export class GetPublicWifiPxsplusAccountsSuccess implements Action {
  type = GET_PUBLIC_WIFI_PXSPLUS_ACCOUNTS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetPublicWifiPxsplusAccountsFailed implements Action {
  type = GET_PUBLIC_WIFI_PXSPLUS_ACCOUNTS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class CreatePublicWifiPxsplusLoginAlias implements Action {
  type = CREATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS;

  constructor(public payload?: any) {}
}

export class CreatePublicWifiPxsplusLoginAliasSuccess implements Action {
  type = CREATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_SUCCESS;

  constructor(public payload: any) {}
}

export class CreatePublicWifiPxsplusLoginAliasFailed implements Action {
  type = CREATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class UpdatePublicWifiPxsplusLoginAlias implements Action {
  type = UPDATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS;

  constructor(public payload?: any) {}
}

export class UpdatePublicWifiPxsplusLoginAliasSuccess implements Action {
  type = UPDATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdatePublicWifiPxsplusLoginAliasFailed implements Action {
  type = UPDATE_PUBLIC_WIFI_PXSPLUS_LOGIN_ALIAS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class UpdatePublicWifiPxsplusPassword implements Action {
  type = UPDATE_PUBLIC_WIFI_PXSPLUS_PASSWORD;

  constructor(public payload?: any) {}
}

export class UpdatePublicWifiPxsplusPasswordSuccess implements Action {
  type = UPDATE_PUBLIC_WIFI_PXSPLUS_PASSWORD_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdatePublicWifiPxsplusPasswordFailed implements Action {
  type = UPDATE_PUBLIC_WIFI_PXSPLUS_PASSWORD_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class ResetPublicWifiPxsplusManageValues implements Action {
  type = RESET_PUBLIC_WIFI_PXSPLUS_MANAGE_VALUES;

  constructor(public payload?: any) {}
}

export class ResetPublicWifiPxsplusCreateValues implements Action {
  type = RESET_PUBLIC_WIFI_PXSPLUS_CREATE_VALUES;

  constructor(public payload?: any) {}
}

export class GetPublicWifiPxsplusConfigureURL implements Action {
  type = GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL;

  constructor(public payload?: any) {}
}

export class GetPublicWifiPxsplusConfigureURLSuccess implements Action {
  type = GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL_SUCCESS;

  constructor(public payload: any) {}
}

export class GetPublicWifiPxsplusConfigureURLFailed implements Action {
  type = GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetPublicWifiPxsplusProducts
  | GetPublicWifiPxsplusProductsSuccess
  | GetPublicWifiPxsplusProductsFailed
  | GetPublicWifiPxsplusAccounts
  | GetPublicWifiPxsplusAccountsSuccess
  | GetPublicWifiPxsplusAccountsFailed
  | UpdatePublicWifiPxsplusLoginAlias
  | UpdatePublicWifiPxsplusLoginAliasSuccess
  | UpdatePublicWifiPxsplusLoginAliasFailed
  | UpdatePublicWifiPxsplusPassword
  | UpdatePublicWifiPxsplusPasswordSuccess
  | UpdatePublicWifiPxsplusPasswordFailed
  | ResetPublicWifiPxsplusManageValues
  | ResetPublicWifiPxsplusCreateValues
  | GetPublicWifiPxsplusConfigureURL
  | GetPublicWifiPxsplusConfigureURLSuccess
  | GetPublicWifiPxsplusConfigureURLFailed;
